<template>
  <MaskLayer>
    <b-spinner variant="success" label="Spinning" />
  </MaskLayer>
</template>

<script>
import MaskLayer from '@/components/MaskLayer';

export default {
  components: {
    MaskLayer
  },
  data() {
    return {

    };
  }
};
</script>
